/* "Zum Warenkorb" button — appears after first add-to-cart on PDP */
(function () {
  function init() {
    var atcComponent = document.querySelector('.product-information add-to-cart-component');
    if (!atcComponent) return;

    var atcButton = atcComponent.querySelector('button[type="submit"]');
    if (!atcButton) return;

    /* Create the "Zum Warenkorb" button */
    var goToCartBtn = document.createElement('button');
    goToCartBtn.type = 'button';
    goToCartBtn.className = 'pdp-go-to-cart';
    goToCartBtn.innerHTML =
      '<svg class="pdp-go-to-cart__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">' +
      '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" ' +
      'd="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686"/>' +
      '</svg>' +
      '<span>Zum Warenkorb</span>';

    /* Insert after the <span> wrapper (not inside it) to avoid stretching the quantity selector */
    var spanWrapper = atcComponent.parentElement;
    spanWrapper.insertAdjacentElement('afterend', goToCartBtn);

    /* Open cart drawer on click */
    goToCartBtn.addEventListener('click', function () {
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    });

    /* Watch for data-added attribute to show button after first add */
    var hasBeenAdded = false;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'data-added') {
          var isAdded = atcButton.getAttribute('data-added') === 'true';
          if (isAdded && !hasBeenAdded) {
            hasBeenAdded = true;
            setTimeout(function () {
              goToCartBtn.style.display = 'flex';
              requestAnimationFrame(function () {
                goToCartBtn.classList.add('is-visible');
              });
            }, 400);
          }
        }
      }
    });

    observer.observe(atcButton, { attributes: true, attributeFilter: ['data-added'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
